import { SuccessData } from 'types/api';
import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';

export const projectSampleMutations = getMutations({
  syncSampleCPI: {
    action: async (payload: { projectId: string }): Promise<SuccessData> => {
      return executeApiCall({
        method: 'post',
        path: 'projects/sample-cpi-sync',
        payload,
      });
    },
  },
});
